export const formatDate = (input) => {
  // Check that input exists and is a string
  if (!input || typeof input !== 'string') {
    return 'N/A';
  }

  try {
    // Check if date has time (ISO format)
    if (input.includes('T')) {
      // Format with time: "2025-03-31T17:43:00"
      const parts = input.split("T");
      if (parts.length < 2) {
        return 'N/A';
      }
      
      const datePart = parts[0].split("-");
      const timePart = parts[1].split(":").slice(0, 2).join(":"); // Keep only hours and minutes

      if (datePart.length < 3) {
        return 'N/A';
      }

      const year = datePart[0];
      const month = datePart[1];
      const day = datePart[2];

      return `${day}/${month}/${year} ${timePart}`;
    } else {
      // Date-only format: "2024-04-18"
      const datePart = input.split("-");
      if (datePart.length < 3) {
        return 'N/A';
      }

      const year = datePart[0];
      const month = datePart[1];
      const day = datePart[2];

      return `${day}/${month}/${year}`;
    }
  } catch (error) {
    // console.error('Error formatting date:', error, 'Input:', input);
    return 'N/A';
  }
};
